import styled from "styled-components"

export const ClusterWrapper = styled.div`
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 2rem 1rem;
  gap: 2rem;

  .add-button {
    justify-items: end;
    width: 100%;
    margin-bottom: 1rem;
  }

  @media (min-width: ${({ theme }) => theme.screen.tablet}) {
    .add-button {
      grid-template-columns: repeat(3, 1fr);
      gap: 2rem;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.screen.smallScreen}) {
    .add-button {
      grid-template-columns: repeat(4, 1fr);
      gap: 2rem;
    }
  }

  .table {
    margin-top: 2rem;

    /* Status styling */
    .status {
      display: flex;
      justify-content: flex-start;

      &.active {
        .status-inner {
          background-color: #dbeafe;
          border: 1px solid #3b82f6;
          border-radius: 20px;
          padding: 0.15rem 0.4rem;
          display: inline-flex;
          align-items: center;
          width: fit-content;
          max-width: 80px;

          h3 {
            color: #1e40af;
            font-size: 0.7rem;
            font-weight: 500;
            margin: 0;
            white-space: nowrap;
          }

          .status-dot {
            display: none;
          }
        }
      }

      &.inactive {
        .status-inner {
          background-color: #fee2e2;
          border: 1px solid #ef4444;
          border-radius: 20px;
          padding: 0.15rem 0.4rem;
          display: inline-flex;
          align-items: center;
          width: fit-content;
          max-width: 80px;

          h3 {
            color: #dc2626;
            font-size: 0.7rem;
            font-weight: 500;
            margin: 0;
            white-space: nowrap;
          }

          .status-dot {
            display: none;
          }
        }
      }
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.screen.smallScreen}) {
  }
`

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 5rem;
`

export const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 2rem;
  margin-bottom: 1.5rem;

  label {
    font-size: 0.875rem;
    font-weight: 500;
    color: #374151;
  }
`

export const ToggleLabel = styled.label`
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`

export const ToggleInput = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;

  &:focus + div {
    outline: none;
    box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.3);
  }
`

export const ToggleSlider = styled.div<{ checked: boolean }>`
  width: 2.75rem;
  height: 1.5rem;
  background-color: ${({ checked }) => (checked ? "#3b82f6" : "#e5e7eb")};
  border-radius: 9999px;
  position: relative;
  transition: background-color 0.2s;

  &::after {
    content: "";
    position: absolute;
    top: 2px;
    left: 2px;
    background-color: white;
    border: 1px solid #d1d5db;
    border-radius: 9999px;
    height: 1.25rem;
    width: 1.25rem;
    transition: transform 0.2s;
    transform: ${({ checked }) => (checked ? "translateX(1.25rem)" : "translateX(0)")};
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 2rem 2rem;
`
